<template lang="pug">
#formulario-filtro-avancado-monitoramento
    .formulario-filtro-avancado-monitoramento-container
        .formulario-filtro-avancado-monitoramento__button
            el-popover(placement='bottom', width='500', trigger='click')
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) Filtros Avançados

                el-form.filtro(label-position='top')
                    .formulario-filtro-avancado-monitoramento-popover-header
                        .formulario-filtro-avancado-monitoramento-popover-header__text Filtros avançados
                        .formulario-filtro-avancado-monitoramento-popover-header__link(
                            @click='aplicar'
                        )
                            | Aplicar filtro

                    .formulario-filtro-avancado-monitoramento-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(title='Biomas', name='biomas')
                                    .el-collapse-item__biomas--loading(
                                        v-loading='!biomas.length'
                                    )
                                        el-checkbox-group(
                                            v-model='biomasSelecionados',
                                            :max='1'
                                        )
                                            el-checkbox(
                                                v-for='(bioma, index) in biomas',
                                                :label='bioma',
                                                :key='index'
                                            )
                                                | {{ bioma.nome }}

                                el-collapse-item(
                                    title='UF/Município',
                                    name='estados'
                                )
                                    .formulario-filtro-avancado-monitoramento-popover-collapse__select(
                                        v-loading='!estados.length'
                                    )
                                        div
                                            el-select(
                                                v-model='estadoSelecionado',
                                                filterable,
                                                value-key='id',
                                                @change='buscarMunicipios()',
                                                placeholder='UF'
                                            )
                                                el-option(
                                                    v-for='(estado, index) in estados',
                                                    :key='index',
                                                    :label='estado.nome',
                                                    :value='estado'
                                                ) {{ estado.nome }}
                                        div
                                            el-select(
                                                v-model='municipioSelecionado',
                                                filterable,
                                                value-key='id',
                                                placeholder='Município'
                                            )
                                                el-option(
                                                    v-for='(municipio, index) in municipios',
                                                    :key='index',
                                                    :label='municipio.nome',
                                                    :value='municipio'
                                                ) {{ municipio.nome }}

    .formulario-filtro-avancado-monitoramento-filtro-selecionado
        span.formulario-filtro-avancado-monitoramento-filtro-selecionado__titulo Filtros selecionados:
        el-tag.formulario-filtro-avancado-monitoramento-filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag.nome }}

        el-tag.formulario-filtro-avancado-monitoramento-filtro-selecionado__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) Limpar filtros
            i.el-icon-delete

        span.formulario-filtro-avancado-monitoramento-filtro-selecionado__nenhum(
            v-else
        ) Nenhum filtro selecionado
</template>

<script>
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import BiomaService from '@/services/BiomaService';
import LocalidadeService from '@/services/LocalidadeService';

export default {
    name: 'FomularioFiltroAvancadoMonitoramento',
    emits: ['atualizar-filtro-avancado'],
    data() {
        return {
            pesquisa: '',
            tags: [],
            collapseFiltroAvancado: [''],
            biomas: [],
            biomasSelecionados: [],
            estados: [],
            estadoSelecionado: {},
            municipios: [],
            municipioSelecionado: {},
            resultadosPesquisa: [],
            resultadosSelecionados: [],
            mostrarResultado: false,
            acaoCollapse: {
                biomas: {
                    collapse: 'biomas',
                    callback: 'buscarBioma'
                },
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            }
        };
    },

    methods: {
        async pesquisar() {
            if (!this.pesquisa) return this.limpar();

            try {
                const { data } =
                    await MonitoramentoSocioambientalService.pesquisar(
                        this.pesquisa
                    );
                this.resultadosPesquisa = data;

                if (!data.length) {
                    this.mostrarResultado = false;
                    this.exibirNotify(
                        'warning',
                        'Não foram encontrados resultados com o texto informado. Verifique a informação inserida ou inicie um novo monitoramento.'
                    );
                } else {
                    this.mostrarResultado = true;
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    'Não foi possível filtrar os dados de monitoramento.'
                );
                throw error;
            }
        },

        aplicar() {
            const filtros = {
                idBiomas: this.biomasSelecionados.map(b => b.id),

                idTerritorios: this.resultadosSelecionados
                    .map(t => t.filtro.idTerritorio)
                    .filter(t => t),
                idRepresentantes: this.resultadosSelecionados
                    .map(r => r.filtro.idRepresentante)
                    .filter(r => r)
            };

            this.tags = [
                ...this.biomasSelecionados,
                ...this.resultadosSelecionados
            ];
            if (this.estadoSelecionado.id && this.municipioSelecionado.id) {
                const estadoMunicipio = {
                    id: this.estadoSelecionado.id,
                    nome: `${this.municipioSelecionado.nome}/${this.estadoSelecionado.sigla}`,
                    codigo: 'ESTADO_MUNICIPIO'
                };
                this.tags.push(estadoMunicipio);
                filtros.idEstado = this.estadoSelecionado.id;
                filtros.idMunicipio = this.municipioSelecionado.id;
            }
            this.tags.sort((a, b) => a.nome.localeCompare(b.nome));

            // Envia os filtros avançados para o componente pai
            this.$emit('atualizar-filtro-avancado', filtros);
        },

        abrirCollapse(ref) {
            if (ref) {
                try {
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length) {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    throw new Error(
                        'Ação não registrada para o collapse:' +
                            ref +
                            ', ERRRO: ' +
                            error
                    );
                }
            }
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);

            this.desmarcarFiltroPopover(filtro);

            this.aplicar();
        },

        desmarcarFiltroPopover(filtro) {
            this.biomasSelecionados = this.biomasSelecionados.filter(
                b => b.codigo !== filtro.codigo
            );
            this.resultadosSelecionados = this.resultadosSelecionados.filter(
                c => c.codigo !== filtro.codigo
            );
            if (filtro.codigo === 'ESTADO_MUNICIPIO') {
                this.estadoSelecionado = {};
                this.municipioSelecionado = {};
            }
        },

        selecionarResultado(resultado) {
            this.adicionarResultado(resultado);

            this.aplicar();
        },

        adicionarResultado(resultado) {
            const filtro = {
                id:
                    resultado.filtro.idTerritorio ||
                    resultado.filtro.idRepresentante,
                filtro: resultado.filtro,
                nome: resultado.valor
            };
            filtro.codigo = `${filtro.id}_${filtro.nome}`;

            const adicionado = this.resultadosSelecionados.find(
                c => c.codigo === filtro.codigo
            );

            if (!adicionado) {
                this.resultadosSelecionados.push(filtro);
            }
        },

        limpar() {
            this.mostrarResultado = false;
            this.resultadosPesquisa = [];
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarResultado = false;
                this.resultadosPesquisa = [];
            }, 300);
        },

        buscarBioma() {
            BiomaService.buscar()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.biomas = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de biomas.'
                    );
                    throw error;
                });
        },

        buscarEstados() {
            LocalidadeService.findEstados(false)
                .then(({ data }) => {
                    setTimeout(() => {
                        this.estados = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },

        buscarMunicipios() {
            LocalidadeService.findMunicipios(this.estadoSelecionado.id, false)
                .then(({ data }) => {
                    this.municipioSelecionado = null;
                    setTimeout(() => {
                        this.municipios = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },

        limparFiltros() {
            [...this.tags].forEach(tag => this.removerFiltro(tag));
        }
    }
};
</script>

<style lang="scss">
.formulario-filtro-avancado-monitoramento-container {
    display: flex;
    justify-content: space-between;
}

.formulario-filtro-avancado-monitoramento-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.formulario-filtro-avancado-monitoramento__resultado {
    position: absolute;
    width: 100%;
}

.formulario-filtro-avancado-monitoramento__resultado__nome {
    margin: 0px 10px;
}

.formulario-filtro-avancado-monitoramento__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.formulario-filtro-avancado-monitoramento__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.formulario-filtro-avancado-monitoramento-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;
}

.formulario-filtro-avancado-monitoramento-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.formulario-filtro-avancado-monitoramento-filtro-selecionado__tag {
    margin: 0px 5px 10px 5px;
}

.formulario-filtro-avancado-monitoramento-filtro-selecionado__limpar {
    margin: 0px 5px 10px 5px;
    i {
        padding-left: 5px;
    }
}

.formulario-filtro-avancado-monitoramento-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.formulario-filtro-avancado-monitoramento-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .formulario-filtro-avancado-monitoramento-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }
    .formulario-filtro-avancado-monitoramento-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.formulario-filtro-avancado-monitoramento-popover-collapse {
    .el-select {
        width: 100%;
    }
    .el-collapse-item__header {
        font-weight: 500;
    }
    .filtro-accordion {
        margin-top: 10px;
    }
    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }
    .el-checkbox-group,
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.formulario-filtro-avancado-monitoramento-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-item__biomas--loading {
    min-height: 100px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}

span.formulario-filtro-avancado-monitoramento-filtro-selecionado__limpar.el-tag.el-tag--info.el-tag--light {
    cursor: pointer;
}
</style>
